import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import com.arenaproplay.admin.pages.AcquisitionPage as _com_arenaproplay_admin_pages_AcquisitionPage
import com.arenaproplay.admin.pages.AdminsPage as _com_arenaproplay_admin_pages_AdminsPage
import com.arenaproplay.admin.pages.AnalyticsPage as _com_arenaproplay_admin_pages_AnalyticsPage
import com.arenaproplay.admin.pages.ApiStatsPage as _com_arenaproplay_admin_pages_ApiStatsPage
import com.arenaproplay.admin.pages.AppLaunchPage as _com_arenaproplay_admin_pages_AppLaunchPage
import com.arenaproplay.admin.pages.AuditLogPage as _com_arenaproplay_admin_pages_AuditLogPage
import com.arenaproplay.admin.pages.BehaviorPage as _com_arenaproplay_admin_pages_BehaviorPage
import com.arenaproplay.admin.pages.ChatPage as _com_arenaproplay_admin_pages_ChatPage
import com.arenaproplay.admin.pages.ClubsPage as _com_arenaproplay_admin_pages_ClubsPage
import com.arenaproplay.admin.pages.ContentStudioPage as _com_arenaproplay_admin_pages_ContentStudioPage
import com.arenaproplay.admin.pages.DashboardPage as _com_arenaproplay_admin_pages_DashboardPage
import com.arenaproplay.admin.pages.EventsPage as _com_arenaproplay_admin_pages_EventsPage
import com.arenaproplay.admin.pages.HomePage as _com_arenaproplay_admin_pages_HomePage
import com.arenaproplay.admin.pages.InboxPage as _com_arenaproplay_admin_pages_InboxPage
import com.arenaproplay.admin.pages.InsightsPage as _com_arenaproplay_admin_pages_InsightsPage
import com.arenaproplay.admin.pages.LoginPage as _com_arenaproplay_admin_pages_LoginPage
import com.arenaproplay.admin.pages.ModerationPage as _com_arenaproplay_admin_pages_ModerationPage
import com.arenaproplay.admin.pages.NewsPage as _com_arenaproplay_admin_pages_NewsPage
import com.arenaproplay.admin.pages.NotFoundPage as _com_arenaproplay_admin_pages_NotFoundPage
import com.arenaproplay.admin.pages.PeoplePage as _com_arenaproplay_admin_pages_PeoplePage
import com.arenaproplay.admin.pages.SettingsPage as _com_arenaproplay_admin_pages_SettingsPage
import com.arenaproplay.admin.pages.SocialPage as _com_arenaproplay_admin_pages_SocialPage
import com.arenaproplay.admin.pages.SubscriptionsPage as _com_arenaproplay_admin_pages_SubscriptionsPage
import com.arenaproplay.admin.pages.SupportPage as _com_arenaproplay_admin_pages_SupportPage
import com.arenaproplay.admin.pages.SystemPage as _com_arenaproplay_admin_pages_SystemPage
import com.arenaproplay.admin.pages.UsersPage as _com_arenaproplay_admin_pages_UsersPage
import com.arenaproplay.admin.pages.clubs.ClubDetailsPage as _com_arenaproplay_admin_pages_clubs_ClubDetailsPage
import com.arenaproplay.admin.pages.events.EventDetailsPage as _com_arenaproplay_admin_pages_events_EventDetailsPage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Arena Admin"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_HomePage()
        }
        ctx.router.register(
            "/404",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_NotFoundPage()
        }
        ctx.router.register(
            "/acquisition",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_AcquisitionPage()
        }
        ctx.router.register(
            "/admins",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_AdminsPage()
        }
        ctx.router.register(
            "/analytics",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_AnalyticsPage()
        }
        ctx.router.register(
            "/api-stats",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_ApiStatsPage()
        }
        ctx.router.register(
            "/app-launch",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_AppLaunchPage()
        }
        ctx.router.register(
            "/audit-log",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_AuditLogPage()
        }
        ctx.router.register(
            "/behavior",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_BehaviorPage()
        }
        ctx.router.register(
            "/chat",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_ChatPage()
        }
        ctx.router.register(
            "/clubs",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_ClubsPage()
        }
        ctx.router.register(
            "/clubs/{id}",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_clubs_ClubDetailsPage()
        }
        ctx.router.register(
            "/content-studio",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_ContentStudioPage()
        }
        ctx.router.register(
            "/dashboard",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_DashboardPage()
        }
        ctx.router.register(
            "/events",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_EventsPage()
        }
        ctx.router.register(
            "/events/{id}",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_events_EventDetailsPage()
        }
        ctx.router.register(
            "/inbox",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_InboxPage()
        }
        ctx.router.register(
            "/insights",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_InsightsPage()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_LoginPage()
        }
        ctx.router.register(
            "/moderation",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_ModerationPage()
        }
        ctx.router.register(
            "/news",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_NewsPage()
        }
        ctx.router.register(
            "/people",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_PeoplePage()
        }
        ctx.router.register(
            "/settings",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_SettingsPage()
        }
        ctx.router.register(
            "/social",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_SocialPage()
        }
        ctx.router.register(
            "/subscriptions",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_SubscriptionsPage()
        }
        ctx.router.register(
            "/support",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_SupportPage()
        }
        ctx.router.register(
            "/system",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_SystemPage()
        }
        ctx.router.register(
            "/users",
        ) { pageCtx -> 
            _com_arenaproplay_admin_pages_UsersPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerKeyframes("modal-fade-in", com.arenaproplay.admin.ui.components.overlay.ModalFadeInKeyframes)
        ctx.theme.registerKeyframes("modal-overlay-fade-in", com.arenaproplay.admin.ui.components.overlay.ModalOverlayFadeInKeyframes)
        ctx.theme.registerKeyframes("toast-slide-in", com.arenaproplay.admin.ui.components.notifications.ToastSlideInKeyframes)
        ctx.theme.registerKeyframes("spin", com.arenaproplay.admin.ui.components.widgets.SpinKeyframes)
        ctx.theme.registerKeyframes("shimmer", com.arenaproplay.admin.ui.components.widgets.ShimmerKeyframes)
        com.arenaproplay.admin.initSilk(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.arenaproplay.admin.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
